import { Link, makeStyles, Stack } from '@fluentui/react';
import * as React from 'react';
import { defineMessages, FormattedMessage } from 'react-intl';
import { useLocalization } from 'src/core/hooks/useLocalization';

const messages = defineMessages({
    deprecationText: {
        id: 'luis.deprecation.banner.text',
        defaultMessage: 'LUIS portal is no longer supported by Microsoft and will be {bold} We recommend migrating to Conversational Language Understanding (CLU) at {link}.'
    },
    disabledDate: {
        id: 'luis.deprecation.banner.disabledDate',
        defaultMessage: 'fully disabled on November 24, 2025'
    },
    link: {
        id: 'luis.deprecation.banner.link',
        defaultMessage: 'ai.azure.com'
    }
});

const useStyles = makeStyles({
    container: {
        padding: '12px 20px',
        width: '100%',
        textAlign: 'center',
        backgroundColor: '#FFF4CE',
        color: '#8A4700',
        fontFamily: 'Segoe UI',
        fontSize: '14px',
        fontWeight: '400',
        display: 'block'
    },
    bold: {
        fontWeight: '600'
    },
    link: {
        color: '#8A4700',
        textDecoration: 'underline'
    }
});

const LuisDeprecationBanner = () => {
    const styles = useStyles();
    const { localize } = useLocalization();

    return (
        <Stack className={styles.container}>
            <FormattedMessage
                {...messages.deprecationText}
                values={{
                    bold: <span className={styles.bold}>{localize(messages.disabledDate)}</span>,
                    link: (
                        <Link href="https://ai.azure.com" target="_blank" className={styles.link}>
                            {localize(messages.link)}
                        </Link>
                    )
                }}
            />
        </Stack>
    );
};

export default LuisDeprecationBanner;
